<template>
	<app-breadcrumb v-if="breadcrumb" :items="[...breadcrumb, ...append]">
	</app-breadcrumb>
</template>

<script>
export default {
	props: {
		append: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			breadcrumb: null,
		}
	},
	watch: {
		$route: {
			immediate: true,
			// @todo - Find a way to not always reprocess breadcrumb for no good reason
			handler(newRoute) {
				const breadcrumbVariables = newRoute.meta.breadcrumbVariables || {}
				const routeParams = { ...newRoute.params, ...breadcrumbVariables }
				if (!newRoute.meta.breadcrumb) { this.breadcrumb = null }
				this.breadcrumb = newRoute.meta.breadcrumb.map((crumb) => {
					const {
						name,
						route,
						params,
						lazyName,
					} = crumb

					const to = { name: route }
					if (params) {
						to.params = params.reduce((acc, param) => {
							acc[param] = routeParams[param]
							return acc
						}, {})
					}
					return { text: name, to, lazyName }
				})
				this.lazyLoad(routeParams)
			},
		},
	},

	methods: {
		async lazyLoad(routeParams) {
			try {
				this.breadcrumb = await Promise.all(this.breadcrumb.map(async (crumb) => {
					if (!crumb.lazyName) { return crumb }
					const dynamicData = await crumb.lazyName.fn.apply(
						null,
						crumb.lazyName.params
							? crumb.lazyName.params.map(param => routeParams[param])
							: [],
					)
					if (!dynamicData) { return crumb }
					return {
						...crumb,
						text: dynamicData[crumb.lazyName.field || '_id'],
					}
				}))
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
	},
}
</script>
